import { useState } from "react"
import { ChevronDown } from "lucide-react"
import { cn } from "@/lib/class-control"
import { Button } from "@/components/ui/button"

interface TimeFilterDropdownProps {
  className?: string
}

const timeOptions = [
  { value: "30", label: "Próximos 30 dias" },
  { value: "60", label: "Próximos 60 dias" },
  { value: "90", label: "Próximos 90 dias" },
  { value: "180", label: "Próximos 180 dias" },
  { value: "365", label: "Próximo ano" },
]

export function TimeFilterDropdown({ className }: TimeFilterDropdownProps) {
  const [selected, setSelected] = useState("90")
  const [isOpen, setIsOpen] = useState(false)

  const selectedLabel = timeOptions.find((opt) => opt.value === selected)?.label || "Nos próximos 90 dias"

  return (
    <div className={cn("relative", className)}>
      <Button
        size="sm"
        variant="outline"
        className={"border-gray-600 text-gray-300 hover:bg-gray-700 h-[50px]"}
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="font-normal text-[#f6f6f6]">
          {selectedLabel}
        </p>
        <ChevronDown className={cn("w-4 h-4 text-white transition-transform", isOpen && "rotate-180")} />
      </Button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown Menu */}
          <div className={cn(
            "absolute top-[calc(100%+8px)] left-0",
            "bg-darkblue border border-gray-700 rounded-md shadow-lg z-20"
          )}>
            <ul>
              {timeOptions.map((option) => (
                <li
                  key={option.value}
                  onClick={() => {
                    setSelected(option.value)
                    setIsOpen(false)
                  }}
                  className={cn(
                    "text-left text-sm px-4 py-2 hover:bg-white/10 transition-colors cursor-pointer",
                    selected === option.value ? "text-primary font-medium" : "text-gray-50"
                  )}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  )
}
